import { render, staticRenderFns } from "./boards-select.vue?vue&type=template&id=dbc33fba"
import script from "./boards-select.vue?vue&type=script&lang=js"
export * from "./boards-select.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports